import styled from "styled-components";
import Icon from "../../../../../base/icons/icon/index.js";
import { SplideWrapper } from "../../../../../structures/others/slider/styled.js";
import Tabs from "../../../../../structures/others/tabs/index.js";
import { TabsButton, TabsWrapper } from "../../../../../structures/others/tabs/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import searcherTabsThemes from "./themes/index.js";
export const SearcherTabsTabs = styled(Tabs).withConfig({
    displayName: "styled__SearcherTabsTabs",
    componentId: "sc-e23d0e8f-0"
})`
	background-color: ${({ theme  })=>theme.colors.secondary.base};

	${TabsButton} {
		min-height: 48px;
		${FlexMixin({
    align: 'center',
    justify: 'center'
})}

		${Icon} {
			${FontMixin({
    size: 'larger',
    weight: 'regular',
    height: 'large'
})}
			margin-right: 8px;

			${({ theme  })=>theme.media.down('xl')} {
				display: none;
			}
		}

		&:not(.is-active) {
			color: ${({ theme  })=>theme.colors.white.base};

			a {
				color: currentColor;
			}

			&:hover {
				color: ${({ theme  })=>theme.colors.primary.light};
			}
		}

		a {
			${FlexMixin({
    align: 'center',
    justify: 'center'
})}
		}
	}

	${TabsWrapper} {
		border-top: 1px solid hsla(0, 0%, 100%, 0.24);
	}

	${SplideWrapper} {
		margin: 0;
		margin-bottom: -1px;

		.splide__arrows {
			.splide__arrow {
				color: ${({ theme  })=>theme.colors.white.base};
				height: 48px;
				width: 32px;
				${FontMixin({
    size: 'large'
})}

				&:hover {
					color: ${({ theme  })=>theme.colors.primary.light};
				}
			}
		}
	}

	${({ theme  })=>searcherTabsThemes[theme.id]?.SearcherTabsTabs?.()}
`;

//# sourceMappingURL=styled.js.map